import store from '@/config/vuex'

export function toggleDocumentOverflow(hasOverflow) {
  if (!document.documentElement.matches('.has-overflow-hidden')) {
    store.commit('page/updateScrollBarWidth')
  }
  const action = hasOverflow ? 'remove' : 'add'
  document.documentElement.classList[action]('has-overflow-hidden')
  equalizeScrollbarWidth(!hasOverflow)
  store.commit(
    'page/setScrollbarEqualizerMargin',
    !hasOverflow ? `${store.state.page.scrollbarWidth}px` : ''
  )
}

export function equalizeScrollbarWidth(equalize) {
  const styleValue = equalize ? `margin-right: ${store.state.page.scrollbarWidth}px` : ''
  document.body.setAttribute('style', styleValue)
}

export function scrollToTop() {
  document.body.scrollTop = document.documentElement.scrollTop = 0
}

export function scrollSmoothlyToElement(element, params = {}) {
  const offset = params.offset || 0
  delete params.offset
  const headerHeight = document.querySelector('header')?.offsetHeight || 0
  const wrapperTopPosition =
    offset - headerHeight + element.getBoundingClientRect().top + window.pageYOffset

  if (!params.scrollUpOnly || window.pageYOffset > wrapperTopPosition) {
    On.smoothScrollTo(wrapperTopPosition, params)
  }
}
